/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div>
    <div class="item-position splitLine-top"></div>
    <div class="item-position logo-item" ><img :src='
`/static/img/${isCj ? "CJ_logo":"sadaLogo"}.png`'/></div>
    <div v-if="!isCj" class="item-position project-name">{{projectInfo.name}}</div>
    <div class="item-position project-status" :class="showStatusClass">
      <div></div>
      <div>{{showStatus}}</div>
      <div class="time-item m-l-30 m-r-30">{{time}}</div>
      <div v-if="!!projectInfo.description" class="dec-item">
        <div>{{$t('projectIntro')}}：</div>
        <div>{{projectInfo.description}}</div>
      </div>
    </div>
    <div class="item-position splitLine-bottom" ></div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const dateFormat = 'YYYY-MM-DD HH:mm:ss'
export default {
  name: 'Header',
  data () {
    return {
      time: dayjs().format(dateFormat),
      isCj: new URLSearchParams(window.location.href.split('?')[1]).get('userType') === 'bjcjjt'
    }
  },
  props: {
    projectInfo: {
      type: Object
    }
  },
  computed: {
    showStatus () {
      switch (this.projectInfo.status) {
        case 0:
          return this.$t('workDoing')
        case 1:
          return this.$t('shutdown')
        case 2:
          return this.$t('finish')
        default:
          return this.$t('undefined')
      }
    },
    showStatusClass () {
      switch (this.projectInfo.status) {
        case 0:
          return 'doing'
        case 1:
          return 'stop'
        case 2:
          return 'finish'
        default:
          return 'no'
      }
    }
  },
  methods: {
    showTime () {
      setInterval(() => {
        this.time = dayjs().format(dateFormat)
      }, 1000)
    }
  },
  created () {
    this.showTime()
  }
}
</script>

<style scoped lang="scss">
  .splitLine-top{
    left:0;
    top:20px;
    width:1800px;
    height:2px;
    background-size: 100% 100%;
    background: url("/static/img/splitLine4.png") no-repeat;
    filter: blur(1px);
  }
  .splitLine-bottom{
    left:0;
    top:120px;
    width:1400px;
    height:2px;
    background-size: 100% 100%;
    background: url("/static/img/splitLine4.png") no-repeat;
    filter: blur(1px);
  }
  .logo-item{
    left: 20px;
    top: 30px;
    height: 80px;
    width: 150px;
    display: flex;
    align-items: center;
    img {
      width: 100%
    }
  }
  .project-name{
    left: 210px;
    top: 38px;
    font-size: 35px;
    font-weight: 500;
  }
  .project-status{
    left: 210px;
    top: 90px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    & > div:first-child{
      width: 15px;
      height:15px;
      background-size: 100% 100% !important;
      margin-right: 10px;
    }
    /*前端简介限制字数在50个以内*/
    .dec-item{
      display: flex;
      div:last-child{
        width: 700px;
        height: 19px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  /*施工中*/
  .doing{
    color:#5f7f9b;
    & > div:first-child{
      background: url('/static/img/shigong.png') center center no-repeat;
    }
  }
  /*准备中*/
  .stop {
    color: #5f7f9b;
    & > div:first-child {
      background: url('/static/img/stop.png') center center no-repeat;
    }
  }
  /*完工*/
  .finish {
    color: #5f7f9b;
    & > div:first-child {
      background: url('/static/img/finish.png') center center no-repeat;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue